/* eslint-disable*/
import VueStoreService from './VueStoreService';
const DetailNationalService = {
  //DETAIL national
  async saveDetail(data, store) {
    var resp = await VueStoreService.post("detail-national", data, store)
    return resp;
  },
  async getDetailxNational(national_id, store) {
    var resp = await VueStoreService.get("detail-national/" + national_id, store)
    return resp;
  },
  
  async deleteDetail(detail_id, store) {
    var resp = await VueStoreService.delete("detail-national/" + detail_id, store)
    return resp;
  },
}

export default DetailNationalService;